// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"42":"1ac46760","318":"11b4d022"}[chunkId] + ".chunk.css";
};